<style scoped>
	@media screen (min-width: 990px) and (max-width: 1410px) {
		.col-md-1 {
			width: 16%;
		}
	}
</style>
<template>
	<div class="panel panel-default">
		<ly-fixheader :title="title" btn="save"></ly-fixheader>	
		<div class="panel-body">
			<form class="form-horizontal">
			  <div class="form-group">
			    <label class="col-sm-2 control-label">管理公司</label>
			    <div class="col-sm-10">
			    	<div class="col-sm-8 pl0">
				    	<select class="form-control" v-model="data.company_id" @change="changeCompany($index)">
				    		<option value="0">---------------- 选择管理公司 ----------------</option>
				    		<option v-for="item in companyList" value="{{item.id}}">{{item.name}}</option>
			    		</select>
		    		</div>
			    </div>
			  </div>
			  <div class="form-group">
			    <label class="col-sm-2 control-label">门店显示名称</label>
			    <div class="col-sm-10">
			    	<div class="col-sm-8 pl0">
				    	<select class="form-control" v-model="data.shop_id">
				    		<option value="0">------------------- 选择门店 -------------------</option>
				    		<option v-for="item in shopList" value="{{item.id}}">{{item.name}}</option>
			    		</select>
		    		</div>
			    </div>
			  </div>
			  <div class="form-group">
			    <label class="col-sm-2 control-label">门店ID</label>
			    <div class="col-sm-10">
			    	<label class="control-label">{{data.shop_id}}</label>
			    	<!-- <input type="text" class="form-control" placeholder="请输入门店id" v-model="data.code"> -->
			    </div>
			  </div>
			  <div class="form-group">
			    <label class="col-sm-2 control-label">门店微信中显示名称 *</label>
			    <div class="col-sm-10">
			      <!-- <input type="text" class="form-control" placeholder="请输入详细地址" v-model="data.address"> -->
					<ly-input :value.sync="data.name" title="微信中显示名称"></ly-input>			      
			    </div>
			  </div>
			  <div class="form-group">
			    <label class="col-sm-2 control-label">区域</label>
			    <div class="col-sm-10">
			    	<div class="col-sm-8 pl0">
			    		<ly-address v-ref:area :address="data.area"></ly-address>
			    	</div>
			    </div>
			  </div>
			  <div class="form-group">
			    <label class="col-sm-2 control-label">详细地址 *</label>
			    <div class="col-sm-10">
			      <!-- <input type="text" class="form-control" placeholder="请输入详细地址" v-model="data.address"> -->
					<ly-input :value.sync="data.address" title="详细地址"></ly-input>			      
			    </div>
			  </div>
			  <div class="form-group">
			    <label class="col-sm-2 control-label">门店电话 *</label>
			    <div class="col-sm-10">
			      	<!-- <input type="text" class="form-control" placeholder="请输入门店电话" v-model="data.phone"> -->
			    	<ly-input :value.sync="data.phone" type="tel" title="门店电话"></ly-input>	
			    </div>
			  </div>
			  <div class="form-group">
			    <label class="col-sm-2 control-label">服务时间</label>
			    <div class="col-sm-6">
			    	<div class="col-sm-2 pl0 pr0">
			    		<select class="form-control" v-model="data.work_time">
				    		<option value="6:00">6:00</option>
				    		<option value="6:30">6:30</option>
			    			<option value="7:00">7:00</option>
			    			<option value="7:30">7:30</option>
			    			<option value="8:00">8:00</option>
			    			<option value="8:30">8:30</option>
			    			<option value="9:00">9:00</option>
			    			<option value="9:30">9:30</option>
			    			<option value="10:00">10:00</option>
			    			<option value="10:30">10:30</option>
			    			<option value="11:00">11:00</option>
			    			<option value="11:30">11:30</option>
			    			<option value="12:00">12:00</option>
			    		</select>
			    	</div>
			    	<div class="col-sm-1 pt6 tc pl0 pr0">~</div>
			    	<div class="col-sm-2 pl0" >
			    		<select class="form-control" v-model="data.rest_time">
				    		<option value="12:00">12:00</option>
			    			<option value="13:00">13:00</option>
			    			<option value="14:00">14:00</option>
			    			<option value="15:00">15:00</option>
			    			<option value="16:00">16:00</option>
			    			<option value="17:00">17:00</option>
			    			<option value="18:00">18:00</option>
			    			<option value="19:00">19:00</option>
			    			<option value="20:00">20:00</option>
			    			<option value="21:00">21:00</option>
			    			<option value="22:00">22:00</option>
			    			<option value="23:00">23:00</option>
			    			<option value="24:00">24:00</option>
			    		</select>
			    	</div>
			    	
			    </div>
			  </div>
			  <div class="form-hr"></div>
			  <div class="form-group">
			    <label class="col-sm-2 control-label">经纬度坐标值</label>
			    <div class="col-sm-10">
			    	<div class="col-sm-8 pl0">
			      		<input type="tel" class="form-control" placeholder="请选择经纬度坐标值" v-model="data.coordinate" @focus="mapContr">
			      	</div>
			    </div>
			  </div>
			  <div class="form-hr"></div>
			  <div class="form-group">
			    <label class="col-sm-2 control-label">门店照片(最多4张)</label>
			  	<div class="col-sm-10">
			  		<div class="col-sm-8 pl0">
				  		<div class="col-sm-3">
				  			<ly-imgupload :image="data.shop_img[0]" v-ref:licone></ly-imgupload>
				  		</div>
				  		<div class="col-sm-3">
				  			<ly-imgupload :image="data.shop_img[1]" v-ref:lictwo></ly-imgupload>
				  		</div>
				  		<div class="col-sm-3">
				  			<ly-imgupload :image="data.shop_img[2]" v-ref:three></ly-imgupload>
				  		</div>
				  		<div class="col-sm-3">
				  			<ly-imgupload :image="data.shop_img[3]" v-ref:four></ly-imgupload>
				  		</div>
				  	</div>
			  	</div>
			  </div>
			  <div class="form-hr"></div>
			  <div class="form-group">
			    <label class="col-sm-2 control-label">提供服务项目</label>
			    <div class="col-sm-10">
			    	<div class="col-sm-8 pl0">
				      	<label class="col-sm-3 servicelist control-label tl" v-for="el in lists">
				      		<input type="checkbox" v-model="data.servicelist" value="{{el}}">&nbsp;{{el}}
				      	</label>
				    </div>
			    </div>
			  </div>
			</form>
	    </div>
	    <!-- 地图start -->
	    <ly-map v-if="isShowMap"></ly-map>
	    <!-- 地图end -->
    </div>
</template>
<script>
	var Http = require('../utils/HttpHelper.js');
	var Common = require('../utils/Common.js');
	var data = {	
		company_id : 0,//所属管理公司ID	
		shop_id : 0,//门店id
		name : '',//门店显示名称
		area: '',//区域(传区域的ID)
		address : '',//详细地址
		phone : '',//电话
		work_time : '6:00',//服务时间
		rest_time : '12:00',
		coordinate : '',//地图坐标
		shop_img : [], //门店照片
		servicelist : [] //门店提供的服务
	};
	var ver = [
		[
			'company_id',Common.isGtZero,'请选择管理公司'
		],
		[
			'shop_id',Common.isGtZero,'请选择门店'
		],
		[
			'coordinate',Common.isNull,'请选择经纬度坐标值'
		],
		[
			'shop_img',Common.isNoArr,'请选择门店照片'
		],
		[
			'servicelist',Common.isNoArr,'请选择提供服务项目'
		]
	];
	/**
	* 返回的处理
	*/
	var goback = function(vm){
		if(vm.isUpdate){
			vm.$dispatch('closeUpdate');
			vm.isUpdate = false;
		}else{
			Common.go('shop_list');
		}
	};
	/**
	* 门店照片的获取
	* @param vm 对应当前的ViewModel
	*/
	var licenseImg = function(vm){
		vm.data.shop_img = [];
		var one = vm.$refs.licone.img;
		if(one.length > 0){
			vm.data.shop_img.push(one);
		}
		var two = vm.$refs.lictwo.img;
		if(two.length > 0){
			vm.data.shop_img.push(two);
		}
		var three = vm.$refs.three.img;
		if(three.length > 0){
			vm.data.shop_img.push(three);
		}
		var four = vm.$refs.four.img;
		if(four.length > 0){
			vm.data.shop_img.push(four);
		}
	};
	/**
	* 区域的获取
	*/
	var getArea = function(vm){
		vm.data.area = vm.$refs.area.fullArea;
	};
	/**
	* 新增
	*/
	var create = function(vm){
		Http['shop'].create({
			data : vm.data,
			succ : function(rs){
				data = {		
					company_id : 0,//所属管理公司ID	
					shop_id : 0,//门店id
					name : '',//门店显示名称
					area: '',//区域(传区域的ID)
					address : '',//详细地址
					phone : '',//电话
					work_time : '7:00',//服务时间
					rest_time : '17:00',
					coordinate : '',//地图坐标
					shop_img : [], //门店照片
					servicelist : [] //门店提供的服务
				};
				Common.tipDialog("提交成功",1500,'success');
				goback(vm);
			},
			err: function(msg){
				Common.tipDialog(msg,1500,'error');
			}
		});			
	};
	/**
	* 修改
	*/
	var save = function(vm){
		Http['shop'].save({
			key : [vm.data.id],
			data : vm.data,
			succ : function(rs){
				Common.tipDialog("保存成功",1500,'success');
				//分发事件		
				goback(vm);
			},
			err: function(msg){
				Common.tipDialog(msg,1500,'error');
			}
		});		
	};
	/**
	* 获取门店列表
	*/
	var getShopList = function(vm){
		Http.shop.list({
			data : {
				company_id : vm.data.company_id
			},
			succ: function(rs){
				vm.shopList = rs;
			}
		});
	};
	/**
	* 获得管理公司列表
	*/
	var getCompanyList = function(vm){
		Http.company.list({
			succ: function(rs){
				vm.companyList = rs;
			}
		});
	};
	module.exports = {
		props : ['info'],//修改时传递过来的数据
		data : function () {
			return {
				lists : ['保养服务','轮胎服务','洗车','美容装饰','故障检测','维修','改装','救援'],
				title: "新增微信门店信息",
				isShowMap : false, //控制地图的显示与隐藏
				data : data,
				isUpdate: false,//标识是[false:新增,true:修改]
				shopList: [],//门店列表
				companyList : [] //管理公司列表
			}
		},
		created : function(){
			getCompanyList(this);//获得管理公司列表
			var self = this;
			setTimeout(function(){
				getShopList(self);
			},200);
			
			if(this.info != undefined){//判断是否有数据，没有表示为新增，有表示为修改
				this.isUpdate = true;
				this.title = "修改微信门店信息";
				this.$set('data',this.info);
				// getShopList(this);//获得门店列表
			}
		},
		components : {
			'ly-address' : require('../components/Address.vue'),
			'ly-imgupload' : require('../components/Imgupload.vue'),
			'ly-map' : require('../components/Map.vue'),
			'ly-fixheader' : require('../components/Fixheader.vue'),
			'ly-input' : require('../components/input/text.vue')
		},
		methods : {
			/**
			* 控制地图的显示与隐藏
			*/
			mapContr : function(){
				this.isShowMap = true;
			},
			/*
			* 选择管理公司
			* @param index 选中的索引
			*/
			changeCompany : function(index){
				this.data.shop_id = 0;
				getShopList(this);//获得门店列表
			}
		},
		events : {
			submit : function(){
				licenseImg(this);//获取门店照片
				getArea(this);//获得选择的区域
				if(Common.isAdopt(this)){
					if(Common.validate(ver,this.data)){
						Common.tipDialog('保存中,请稍后...',0,'loading');
						var self = this;
						if(self.isUpdate){
							save(self);
						}else{
							create(self);
						}
					}
				}
			},
			goback : function(){
				Common.go('shop_list');
			},
			pointChange : function(point){
				this.data.coordinate = point;
			},
			mapClose : function(){
				this.isShowMap = false;
			}
		}
	}
</script>


/** WEBPACK FOOTER **
 ** shop_add.vue?7d59c514
 **/